module.exports = __webpack_public_path__ + "img/jef-logo.cae14947.svg";